const FAVICON_SELECTOR = 'link.favicon, link[rel="icon"][type="image/svg+xml"]';

const badgeHrefFor = favicon => {
  const size = favicon.sizes?.[0] || '32x32';
  return `/favicon-badge-${size}.png`;
};

const rememberOriginalHref = favicon => {
  if (!favicon.dataset.originalHref) {
    favicon.dataset.originalHref = favicon.getAttribute('href');
  }
  if (!favicon.dataset.originalType) {
    favicon.dataset.originalType = favicon.getAttribute('type') || '';
  }
};

export const showBadgeOnFavicon = () => {
  document.querySelectorAll(FAVICON_SELECTOR).forEach(favicon => {
    rememberOriginalHref(favicon);
    favicon.type = 'image/png';
    favicon.href = badgeHrefFor(favicon);
  });
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      return;
    }

    document.querySelectorAll(FAVICON_SELECTOR).forEach(favicon => {
      if (!favicon.dataset.originalHref) {
        return;
      }

      favicon.href = favicon.dataset.originalHref;
      if (favicon.dataset.originalType) {
        favicon.type = favicon.dataset.originalType;
      } else {
        favicon.removeAttribute('type');
      }
    });
  });
};
